"use strict";
exports.__esModule = true;
exports.isMobile = void 0;
/** 是否是手机 */
function isMobile() {
    if (navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.toLowerCase().indexOf('iphone') > -1 || navigator.userAgent.toLowerCase().indexOf('mobile') > -1) {
        return true;
    }
    return false;
}
exports.isMobile = isMobile;
